import * as chartTypes from '../components/chartview/panels/document/chart-types/chart-types.constants';

/** An array of possible chart types suitable for provided data.
 * This function doesn't include publication preferences.
 * @param {{series:[], type:string, tickers:[object], categories:[], parsed: [object]}} data Parsed chart data.
 * @returns {ChartTypeDescription[]} of possible charts the data is suitable for.
 */
export default function possibleCharts(data) {
  const { series, type, tickers, categories, parsed } = data;
  if (!series?.length) return [];

  if (type === 'market') {
    if (tickers?.length === 1 || (!tickers && series?.length === 1)) {
      return chartTypes.MARKET_SINGLE_TICKER;
    }
    return chartTypes.MARKET_MULTI_TICKER;
  }
  return chartTypes.POSSIBLE_CHARTS.filter((chartType) => {
    if (
      !chartTypes.CHART_TYPES[chartType.type].categoryLimit &&
      !chartTypes.CHART_TYPES[chartType.type].seriesLimit
    )
      return true;

    const { categoryLimit, seriesLimit } = chartTypes.CHART_TYPES[chartType.type];
    if (categoryLimit && seriesLimit)
      return (
        categories.length >= categoryLimit.min &&
        categories.length <= categoryLimit.max &&
        series.length <= seriesLimit.max &&
        series.length >= seriesLimit.min
      );

    if (categoryLimit)
      return categories.length >= categoryLimit.min && categories.length <= categoryLimit.max;

    if (seriesLimit) {
      // For scatter type `data.series` array is weirdly gets modified in some unknown place.
      // For ex. when pasting 4 column data, series length first gets set to 4,then when switching to scatter and saving, series length updates to 2.
      // `data.parsed` seems to be stable at least for scatter.
      const seriesLength = chartType.type === 'scatter' ? parsed[0].length : series.length;
      return seriesLength <= seriesLimit.max && seriesLength >= seriesLimit.min;
    }
  });
}
